import { UserFragment } from 'modules/user/gql/generated/UserFragment';
import { createContext } from 'react';

type UserContextType = UserFragment | undefined;

export const UseUserContext = createContext<UserContextType>(undefined);
